import {
  Box,
  FormControl,
  IconButton,
  MenuItem,
  Select,
  Typography,
} from "@mui/material";
import { useState } from "react";
import ArrowUpwardOutlinedIcon from "@mui/icons-material/ArrowUpwardOutlined";
import ArrowDownwardOutlinedIcon from "@mui/icons-material/ArrowDownwardOutlined";
import { splitCamelCaseToWords } from "../../utils/Formatter";

interface HeaderWithSelectProps {
  field: string;
  sortField: string;
  headerName: string | undefined;
  showFilter: boolean;
  width?: number;
  values?: any[];
  onFilterSubmit?: any;
  disabled?: boolean;
}
export default function TableHeaderSelectField({
  field,
  sortField,
  headerName,
  showFilter,
  width,
  values,
  onFilterSubmit,
  disabled = false,
}: HeaderWithSelectProps) {
  const dropdownWidth = width && width - 20;
  const [sort, setSort] = useState("asc");
  const [selectedValue, setSelectedValue] = useState("");
  const toggleSorting = () => {
    onFilterSubmit({ sortColumn: sortField, sortOrder: sort });
    setSort(sort === "asc" ? "desc" : "asc");
  };
  const onSelectChange = (event: any) => {
    const value = event.target.value;
    setSelectedValue(value);
    if (field === "isActive") {
      value === "Active"
        ? onFilterSubmit({ [field]: true })
        : onFilterSubmit({ [field]: false });
    } else if (field === "isRushInspection") {
      value === "Yes"
        ? onFilterSubmit({ [field]: true })
        : onFilterSubmit({ [field]: false });
    } else if (field === "isResolved") {
      value === "Resolved"
        ? onFilterSubmit({ [field]: true })
        : onFilterSubmit({ [field]: false });
    } else {
      onFilterSubmit({ [field]: value });
    }
  };
  return (
    <Box sx={{ width, pr: 1 }}>
      <Box className="header" sx={{ display: "flex", alignItems: "center" }}>
        <Typography sx={{ fontWeight: "bold" }}>{headerName}</Typography>
        <IconButton aria-label="sort" onClick={toggleSorting}>
          {sort === "asc" ? (
            <ArrowUpwardOutlinedIcon
              className="ArrowUpwardIcon"
              sx={{ fontSize: 17, display: "none" }}
            />
          ) : (
            <ArrowDownwardOutlinedIcon
              className="ArrowUpwardIcon"
              sx={{ fontSize: 17, display: "none" }}
            />
          )}
        </IconButton>
      </Box>
      <FormControl sx={{ display: showFilter ? "block" : "none", mt: 1 }}>
        <Select
          labelId="demo-simple-select-label"
          id="demo-simple-select"
          size="small"
          sx={{
            width: dropdownWidth,
            "& .MuiSelect-select span::before": {
              content: "'Select'",
              color: "rgba(0, 0, 0, 0.42)",
            },
          }}
          value={selectedValue}
          onChange={onSelectChange}
          disabled={disabled}
        >
          {values?.map((type: any) => {
            return typeof type === "string" ? (
              <MenuItem key={type} value={type}>
                {type && splitCamelCaseToWords(type)}
              </MenuItem>
            ) : (
              <MenuItem key={type?.value} value={type?.value}>
                {type?.label}
              </MenuItem>
            );
          })}
        </Select>
      </FormControl>
    </Box>
  );
}
